import ArticleForm, { ArticleFormType } from "./article-form.ts";

export class DirectOrderForm {
  static Selector = '[data-type="direct-order-form"]';

  #element: HTMLElement;

  #newArticleForm: ArticleForm;

  #submitButton: HTMLButtonElement;

  #articleForms: Map<number, ArticleForm> = new Map();

  constructor(element: HTMLElement) {
    this.#element = element;

    const submitButton = element.querySelector('button[type="submit"]');
    const newArticleFormElement = element.querySelector(
      ArticleForm.Selector(ArticleFormType.New),
    );
    const articleFormElements = Array.from(
      element.querySelectorAll(ArticleForm.Selector(ArticleFormType.Existing)),
    );

    if (
      submitButton instanceof HTMLButtonElement &&
      newArticleFormElement instanceof HTMLElement
    ) {
      this.#submitButton = submitButton;
      this.#submitButton.addEventListener("click", this.#onSubmitButtonClick);

      this.#newArticleForm = new ArticleForm(
        newArticleFormElement,
        ArticleFormType.New,
      );
      this.#newArticleForm.addEventListener(
        ArticleForm.ChangeEventType,
        this.#onNewArticleFormChange,
      );
    }

    for (const element of articleFormElements) {
      if (element instanceof HTMLElement) {
        this.#addArticleForm(
          new ArticleForm(element, ArticleFormType.Existing),
        );
      }
    }
  }

  get hasError() {
    return this.#element.dataset.hasError === "true";
  }

  get viewportMin() {
    return Number(this.#element.dataset.viewportMin) || 0;
  }

  get viewportMax() {
    return (
      Number(this.#element.dataset.viewportMax) || Number.POSITIVE_INFINITY
    );
  }

  scrollIntoView() {
    const scrollMarker =
      this.#element.closest("[data-scroll-marker]") || this.#element;

    scrollMarker.scrollIntoView({ block: "start" });
  }

  #addArticleForm(articleForm: ArticleForm) {
    const index = this.#articleForms.size;

    articleForm.index = index;
    articleForm.addEventListener(
      ArticleForm.ChangeEventType,
      this.#onArticleFormChange,
    );

    this.#articleForms.set(index, articleForm);
  }

  #removeArticleForm(articleForm: ArticleForm) {
    articleForm.element.remove();

    this.#articleForms.delete(articleForm.index);
  }

  #onNewArticleFormChange = (e: Event) => {
    const articleForm = e.target;

    if (articleForm instanceof ArticleForm && articleForm.articleId !== "") {
      articleForm.removeEventListener(
        ArticleForm.ChangeEventType,
        this.#onNewArticleFormChange,
      );
      articleForm.type = ArticleFormType.Existing;

      this.#newArticleForm = articleForm.clone();
      this.#newArticleForm.articleId = "";
      this.#newArticleForm.addEventListener(
        ArticleForm.ChangeEventType,
        this.#onNewArticleFormChange,
      );

      articleForm.element.after(this.#newArticleForm.element);

      this.#addArticleForm(articleForm);
    }
  };

  #onArticleFormChange = (e: Event) => {
    if (e.target instanceof ArticleForm && e.target.articleId === "") {
      this.#removeArticleForm(e.target);
    }
  };

  #onSubmitButtonClick = (e: Event) => {
    if (this.#articleForms.size === 0) {
      e.preventDefault();
      return;
    }

    requestAnimationFrame(() => {
      // disable submit after first click
      this.#submitButton.disabled = true;
    });
  };
}
